module.exports = __webpack_public_path__ + "img/Anhänger_Werkstatt.09c713a2.svg";